// Lets one sidebar tab send staff to another (T-212: the Documents tab's empty
// TruStage certificate row points at the Details tab's pre-need timeline).
import { useEffect } from 'react';

const EVENT = 'cleo:open-sidebar-tab';

interface OpenTabDetail {
  tab: string;
  /** data-testid of the element to scroll into view once the tab shows. */
  target?: string;
}

export function openSidebarTab(tab: string, target?: string): void {
  window.dispatchEvent(
    new CustomEvent<OpenTabDetail>(EVENT, { detail: { tab, target } })
  );
}

export function useSidebarTabRequests(onOpen: (tab: string) => void): void {
  useEffect(() => {
    const handler = (e: Event) => {
      const { tab, target } = (e as CustomEvent<OpenTabDetail>).detail ?? {};
      if (!tab) return;
      onOpen(tab);
      if (target)
        window.setTimeout(() => {
          document
            .querySelector(`[data-testid="${target}"]`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 50);
    };
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, [onOpen]);
}
